import * as React from 'react';
import {Tabs as VWTabs} from '@volkswagen-onehub/components-core';
import {TabsProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
export function Tabs({
  children,
  onChange,
  defaultIndex,
}: TabsProps): JSX.Element {
  return (
    <VWTabs
      idPrefix="e-mobility-tab"
      variant="underlined"
      tabBarVerticalPosition="bottom"
      scrollable={true}
      onChange={onChange}
      defaultIndex={defaultIndex}
    >
      {children}
    </VWTabs>
  );
}
